<template>
<el-main class='sge'>
  <v-card class="kk">
<v-card-title>
List Of Recent videos
</v-card-title>

      <v-btn color="info"
                 target="_blank"
                 href="http://www.tinsanity.net/404.shtml">
      <i class="el-icon-video-camera-solid"></i>more?</v-btn>

      <div class="item">
        <div class="player">
          <video-player  class="vjs-custom-skin"
                         ref="videoPlayer"
                         :options="playerOptions"
                         :playsinline="true"
                         @play="onPlayerPlay($event)"
                         @pause="onPlayerPause($event)"
                         @ended="onPlayerEnded($event)"
                         @loadeddata="onPlayerLoadeddata($event)"
                         @waiting="onPlayerWaiting($event)"
                         @playing="onPlayerPlaying($event)"
                         @timeupdate="onPlayerTimeupdate($event)"
                         @canplay="onPlayerCanplay($event)"
                         @canplaythrough="onPlayerCanplaythrough($event)"
                         @ready="playerReadied"
                         @statechanged="playerStateChanged($event)">
          </video-player>
          <v-spacer></v-spacer>
          
        </div>
      </div>
  </v-card>
  <v-card class="kk">
<v-card-title>
List Of Recent videos
</v-card-title>

      <v-btn color="info"
                 target="_blank"
                 href="http://www.tinsanity.net/404.shtml">
      <i class="el-icon-video-camera-solid"></i>more?</v-btn>
      <video-player  class="vjs-custom-skin"
                         ref="videoPlayer"
                         :options="playerOptions2"
                         :playsinline="true"
                         @play="onPlayerPlay($event)"
                         @pause="onPlayerPause($event)"
                         @ended="onPlayerEnded($event)"
                         @loadeddata="onPlayerLoadeddata($event)"
                         @waiting="onPlayerWaiting($event)"
                         @playing="onPlayerPlaying($event)"
                         @timeupdate="onPlayerTimeupdate($event)"
                         @canplay="onPlayerCanplay($event)"
                         @canplaythrough="onPlayerCanplaythrough($event)"
                         @ready="playerReadied"
                         @statechanged="playerStateChanged($event)">
          </video-player>
  </v-card>
</el-main>
</template>

<script>
  // custom skin css
  import '../../node_modules/vue-video-player/src/custom-theme.css' 

  export default {
    data() {
      return {
        // videojs options
        playerOptions: {
          height: '360',
          autoplay: false,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            // mp4
            src: "https://firebasestorage.googleapis.com/v0/b/demobo-1c473.appspot.com/o/Battlefield%205_%20Random%20%26%20Funny%20Moments%20%2319.mp4?alt=media&token=242044ff-bf87-454f-a843-cd83541dc4ef",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1556675321797&di=638acaf8b68a4bb2d1909bc2a8819072&imgtype=0&src=http%3A%2F%2Fp0.so.qhimgs1.com%2Ft019379cc6c89f81e9c.jpg",
        },
        playerOptions2: {
          height: '360',
          autoplay: false,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            // mp4
            src: "https://firebasestorage.googleapis.com/v0/b/demobo-1c473.appspot.com/o/Forgot%20how%20to%20dark%20souls.mp4%20%5B1%2C000%20subs%20special%5D.mp4?alt=media&token=92915305-7d47-4c4e-9496-c37a3dd46d5f",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: "https://t.facdn.net/30706019@400-1551769251.jpg",
        }
      }
    },
    mounted() {
      console.log('this is current player instance object', this.player)
      setTimeout(() => {
        console.log('dynamic change options', this.player)
        // change src
        this.playerOptions.sources[0].src = 'https://firebasestorage.googleapis.com/v0/b/demobo-1c473.appspot.com/o/Battlefield%205_%20Random%20%26%20Funny%20Moments%20%2319.mp4?alt=media&token=242044ff-bf87-454f-a843-cd83541dc4ef';
        // change item0
        this.$set(this.playerOptions.sources, 0, {
        type: "video/mp4",
        src: 'https://firebasestorage.googleapis.com/v0/b/demobo-1c473.appspot.com/o/Battlefield%205_%20Random%20%26%20Funny%20Moments%20%2319.mp4?alt=media&token=242044ff-bf87-454f-a843-cd83541dc4ef',
        })
        // change array
        this.playerOptions.sources = [{
        type: "video/mp4",
        src: 'https://firebasestorage.googleapis.com/v0/b/demobo-1c473.appspot.com/o/Battlefield%205_%20Random%20%26%20Funny%20Moments%20%2319.mp4?alt=media&token=242044ff-bf87-454f-a843-cd83541dc4ef',
        }]
        this.player.muted(false)
      }, 5000)
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      // listen event
      onPlayerPlay(player) {
        // console.log('player play!', player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      onPlayerEnded(player) {
        // console.log('player ended!', player)
      },
      onPlayerLoadeddata(player) {
        // console.log('player Loadeddata!', player)
      },
      onPlayerWaiting(player) {
        // console.log('player Waiting!', player)
      },
      onPlayerPlaying(player) {
        // console.log('player Playing!', player)
      },
      onPlayerTimeupdate(player) {
        // console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        // console.log('player Canplay!', player)
      },
      onPlayerCanplaythrough(player) {
        // console.log('player Canplaythrough!', player)
      },
      // or listen state event
      playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },
      // player is ready
      playerReadied(player) {
        // seek to 10s
        console.log('example player 1 readied', player)
        player.currentTime(0)
        // console.log('example 01: the player is readied', player)
      }
    }
  }
</script>
<style>
.sge {
  margin-left: 5%;
  width: 90%;
  height: 100%;
  overflow-x: hidden;}

</style>
